import { IThunkActionCreator } from '..';
import { selectRequestParameters } from './selectors';
import { postHideOffer } from '../../api/hidden_objects';
import { trackHiddenObjects, EHideOfferAnalyticsCategory, selectProductsParams } from '../../tracking/hide_offer';
import { setOfferHidden } from '../offer';
import { setHideOfferState } from './actions';
import { EHideOfferState } from './types';
import { requestAuthentication } from '../../actions/authentication';

export const errorMessages = {
  errorWhileHide: 'Ошибка при попытке скрыть объявление',
  errorWhileRestore: 'Ошибка при попытке восстановить объявление',
  limitExceeded: 'Вы можете скрыть не более 1000 объявлений',
};

const LIMIT_EXCEEDED_ERROR_CODE = 'limitExceeded';

export function hideOffer(): IThunkActionCreator<Promise<void>> {
  return async (dispatch, getState, context) => {
    const state = getState();
    const parameters = selectRequestParameters(state);
    const isAuthenticated = state.offerData.user && state.offerData.user.isAuthenticated;
    const { httpApi } = context;
    if (!isAuthenticated) {
      dispatch(requestAuthentication({ onSuccess: hideOffer }));

      return;
    }

    dispatch(setHideOfferState({ status: EHideOfferState.FETCHING }));

    return postHideOffer(httpApi, parameters)
      .then(result => {
        if (result.statusCode === 200) {
          dispatch(setHideOfferState({ status: EHideOfferState.SUCCESS }));
          dispatch(setOfferHidden(true));
          trackHiddenObjects({
            action: 'Hide',
            category: EHideOfferAnalyticsCategory.HIDE,
            productParams: selectProductsParams(state),
          });
        } else if (result.statusCode === 400) {
          const { errors } = result.response;
          const isLimitExceededError =
            errors && errors.length > 0 && (errors[0] as { [key: string]: string }).code === LIMIT_EXCEEDED_ERROR_CODE;
          const payload = isLimitExceededError
            ? { status: EHideOfferState.ERROR, errorMessage: errorMessages.limitExceeded }
            : { status: EHideOfferState.ERROR, errorMessage: errorMessages.errorWhileHide };

          dispatch(setHideOfferState(payload));
        }
      })
      .catch((error: Error) => {
        context.logger.error(error, { details: 'Failed to hide offer' });
        dispatch(
          setHideOfferState({
            status: EHideOfferState.ERROR,
            errorMessage: errorMessages.errorWhileHide,
          }),
        );
      });
  };
}
